import { jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { FormRoot } from "./formContext.js";
import { useCreateForm } from "./useCreateForm.js";
function FormProvider(props) {
  const { config, verbose, children, onFormApi, onInitialize } = props;
  const formState = useCreateForm(config, verbose);
  const { api } = formState;
  const rTryToInitialize = useRef(false);
  const [initialized, setInitialized] = useState(() => onInitialize === void 0);
  useEffect(() => {
    onFormApi?.(api);
  }, [onFormApi, api]);
  useEffect(() => {
    if (!onInitialize) return;
    if (rTryToInitialize.current) return;
    const userConfig = onInitialize();
    api.initialize(userConfig);
    rTryToInitialize.current = true;
    setInitialized(true);
  }, [api]);
  if (!initialized) return null;
  return /* @__PURE__ */ jsx(FormRoot, { formState, children });
}
export {
  FormProvider
};
//# sourceMappingURL=FormProvider.js.map
